import type {
  MicroUnitTokenClasses,
  MicroUnitSettings,
} from '../ModularTypes/MicroUnitSettings';
import type { As } from '../ModularTypes/MicroUnitSettings';
import type { ElementType, ReactNode } from 'react';

type ClassValue = string | undefined | null;

export class MicroUnitClassBuilder {
  static build(
    props: MicroUnitSettings<As>,
    context: Partial<MicroUnitTokenClasses> = {},
  ): string {
    const get = <T extends keyof MicroUnitTokenClasses>(
      key: T,
    ): string | undefined => props[key] || context[key];

    const toClass = (prefix: string, value?: string) =>
      value ? `${prefix}-${value}` : null;

    const typographyClasses =
      props.as === 'h1'
        ? toClass('h1-typography', props.h1Typography)
        : props.as === 'h2'
          ? toClass('h2-typography', props.h2Typography)
          : props.as === 'p'
            ? toClass('p-typography', props.pTypography)
            : props.as === 'label'
              ? toClass('label-typography', props.labelTypography)
              : null;

    const colorClasses =
      props.as === 'h1'
        ? toClass('h1-color', props.h1Color)
        : props.as === 'h2'
          ? toClass('h2-color', props.h2Color)
          : props.as === 'p'
            ? toClass('p-color', props.pColor)
            : props.as === 'label'
              ? toClass('label-color', props.labelColor)
              : null;

    return [
      'microunit',
      props.className ?? context.className,

      toClass('grid-area', get('gridArea')),

      get('overLay'),
      toClass('col-span', get('colSpan')),
      toClass('row-span', get('rowSpan')),

      toClass('spacing', get('spacing')),
      toClass('width', get('width')),
      toClass('height', get('height')),

      // toClass('justify-content', get('justifyContent')),
      // toClass('justify-items', get('justifyItems')),
      // toClass('align-content', get('alignContent')),
      // toClass('align-items', get('alignItems')),
      toClass('align-self', get('alignSelf')),
      toClass('justify-self', get('justifySelf')),
      toClass('padding-left', get('paddingLeft')),
      toClass('padding-right', get('paddingRight')),
      toClass('padding-top', get('paddingTop')),
      toClass('padding-bottom', get('paddingBottom')),
      toClass('margin-left', get('marginLeft')),
      toClass('margin-right', get('marginRight')),
      toClass('margin-top', get('marginTop')),
      toClass('margin-bottom', get('marginBottom')),

      toClass('box-shadow', get('boxShadow')),
      toClass('z-index', get('zIndex')),
      toClass('bg', get('background')),

      typographyClasses,
      colorClasses,
    ]
      .filter(this.isValid)
      .join(' ');
  }

  static isValid(value: ClassValue): value is string {
    return typeof value === 'string' && value.trim() !== '';
  }
}
